import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import Moon from "../packages/Moon";
import Common from "./Common";
import Close from "@material-ui/icons/Close";
import createAbsoluteGrid from "AbsoluteGrid/AbsoluteGrid";
import GridItem from "components/GridItem";
import ClientSite from "components/ClientSite";
import Typography from "@material-ui/core/Typography";

const styles = {
	root: {
		height: "calc(100% - 38px)",
		width: "100%",
		flexDirection: "row",
		flexWrap: "nowrap",
		alignItems: "center",
		justifyContent: "space-evenly"
	},
	searchElements: {
		height: "calc(100% - 48px)",
		width: "100%",
		overflow: "hidden",
		overflowY: "auto",
		boxSizing: "border-box",
		padding: "10px 10px"
	},
	searchElement: {
		boxShadow: "0 0 1.25em 0 rgba(0,0,0,.2)",
		width: "100%",
		height: "100%",
		backgroundColor: "white"
	},
	searchElementImg: {
		backgroundColor: "#fff",
		width: "100%",
		height: "200px",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundSize: "contain"
	}
};

const classes = StyleSheet.create({
	noResultsButton: {
		width: "100%"
	},
	titleDiv: {
		display: "flex",
		justifyContent: "start",
		alignItems: "center",
		height: "48px"
	},
	titleText: {
		width: "100%",
		padding: "0px 5px 0px 0px",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		overflow: "hidden"
	}
});

class SearchResults extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			searchValue: Moon.use(null),
			searchElements: Moon.use(null),
			gridBoxContainer: null
		};
		this.gridBoxContainer = React.createRef();
		this.dragElement = null;
		this.onMoveOnce = false;

		this.onMove = this.onMove.bind(this);
		this.onDragStart = this.onDragStart.bind(this);
		this.onDragEnd = this.onDragEnd.bind(this);
	}

	componentWillMount() {
		Moon.addStar(this);
	}

	componentDidMount() {}

	componentDidUpdate(prevProps, prevState) {
		if (
			this.gridBoxContainer != null &&
			this.gridBoxContainer.current != null &&
			this.state.gridBoxContainer != this.gridBoxContainer.current
		) {
			this.setState({ gridBoxContainer: this.gridBoxContainer.current });
		}
	}

	onDragStart(elem) {
		if (this.dragElement != null || elem == null) return;
		this.dragElement = elem;
		Common.setStyleToGridItem(elem, "transform", "scale(1.1)");
	}

	onMove(from, to) {
		if (from == to || ClientSite.isInsideGrid() == false) return;
		this.onMoveOnce = true;
		ClientSite.onMove(from, to, true);
	}

	onDragEnd(e) {
		ClientSite.clearHiddenElement();
		if (this.dragElement == null) return;
		Common.setStyleToGridItem(this.dragElement, "transform", null);
		if (ClientSite.isInsideGrid() && this.onMoveOnce) {
			this.dragElement.sort = 9999;
			this.dragElement.disabled = true;
			let index = 0;
			let newSearchElements = this.state.searchElements.map(e => {
				let item = Object.assign({}, e);
				if (item.key != this.dragElement.key && item.disabled != true) {
					item.sort = index;
					index++;
				}
				return item;
			});
			this.setState({ searchElements: newSearchElements });
		}
		this.dragElement = null;
		this.onMoveOnce = false;
	}

	AbsoluteGrid = createAbsoluteGrid(
		GridItem,
		{
			selectableItems: false,
			showSort: false,
			imageContainer: {
				position: "relative",
				overflow: "hidden",
				width: "180px",
				height: "200px",
				boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 1em 0px",
				zIndex: 2
			},
			footer: {
				backgroundColor: "#91a5b9",
				width: "100%",
				height: "40px",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				color: "white",
				cursor: "default",
				position: "relative",
				overflow: "hidden"
			},
			priceText: {
				fontSize: "0.8rem",
				color: "white"
			}
		},
		false
	);

	render() {
		if (this.props.open == false) return null;
		if (this.state.searchValue == null || this.state.searchValue == "")
			return (
				<div style={styles.root}>
					<Button
						classes={{
							root: css(classes.noResultsButton)
						}}
					>
						{" "}
						No results
					</Button>
				</div>
			);
		return (
			<div style={styles.root}>
				<div className={css(classes.titleDiv)}>
					<Button
						classes={{ root: css(classes.titleButton) }}
						dense={true}
						onClick={() => Common.clearSearch(this)}
					>
						<Close />
					</Button>
					<Typography
						classes={{ root: css(classes.titleText) }}
						variant="body1"
					>
						{this.state.searchValue}
					</Typography>
				</div>
				<div ref={this.gridBoxContainer} style={styles.searchElements}>
					<this.AbsoluteGrid
						gridName={"search"}
						setInsideGrid={true}
						items={this.state.searchElements}
						onMove={this.onMove}
						onDragStart={this.onDragStart}
						onDragEnd={this.onDragEnd}
						dragEnabled={true}
						zoom={1}
						responsive={true}
						verticalMargin={10}
						itemWidth={210}
						itemHeight={340}
						animation={"transform 200ms ease 0s"}
						itemsPerRow={1}
						containerZoom={1}
						gridBoxContainer={this.state.gridBoxContainer}
					/>
					<div style={{ height: "10px" }} />
				</div>
			</div>
		);
	}
}

export default SearchResults;
